import api from "./api";

const route = "/courses";

const PaquetesService = {
  getPaquetes: () => api.get(route),
  getPaquete: (course_id) => api.get(`${route}/${course_id}`),
  getOnline: () => api.get(`${route}/online/all`),
  getAllPaquetes: () => api.get(`${route}/admin/all`),
  getOnlineHome: () => api.get(`${route}/online/home`),
  getPresenciales: () => api.get(`${route}/presenciales/all`),
  getPresencialesHome: () => api.get(`${route}/presenciales/home`),
  getAsistentesEspecial: (package_class_id) =>
    api.get(`${route}/especiales/${package_class_id}/asistentes`),
  getEventosEspecialesHome: () => api.get(`${route}/especiales/home`),
  getPaquetesEspeciales: () => api.get(`${route}/especiales/all`),
};

export default PaquetesService;
